module.exports = __webpack_public_path__ + "img/DE05908.479b2588.png";